import React from 'react';
import './MiddlePillNavbar.css';

function MiddlePillNavbar({ activeTab, setActiveTab }) {
  return (
    <div className="middle-pill-navbar-container">
      <button
        className={`pill-button ${activeTab === 'work' ? 'active' : ''}`}
        onClick={() => setActiveTab('work')}
        type="button"
      >
        Work
      </button>
      <button
        className={`pill-button ${activeTab === 'hobbies' ? 'active' : ''}`}
        onClick={() => setActiveTab('hobbies')}
        type="button"
      >
        Hobbies
      </button>
    </div>
  );
}

export { MiddlePillNavbar };
